export default function About() {
  return (
    <section id="chi-siamo" className="py-32 bg-[#F8F6F3]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Text Content */}
          <div>
            <div className="inline-block bg-gray-200 px-4 py-2 rounded-full mb-6">
              <p className="text-[#2C2C2C] text-sm font-medium uppercase tracking-wide">
                LA NOSTRA STORIA
              </p>
            </div>
            
            <h2 className="text-5xl lg:text-6xl font-bold text-[#2C2C2C] leading-tight mb-10">
              LIOS S.r.l.<br />
              INNOVAZIONE<br />
              DAL 2016
            </h2>
            
            <p className="text-gray-600 text-lg font-light leading-relaxed mb-8">
              Con sede a Napoli in Via Gaetano Argento 14, Lios S.r.l. è specializzata in attività di programmazione informatica, offrendo soluzioni tecnologiche all'avanguardia per aziende di ogni dimensione.
            </p>

            <p className="text-gray-600 text-lg font-light leading-relaxed mb-8">
              La nostra missione è trasformare le sfide digitali in opportunità di crescita, combinando competenze tecniche avanzate con una profonda comprensione delle esigenze aziendali. Ogni progetto è un'occasione per creare valore attraverso l'innovazione.
            </p>

            <div className="grid grid-cols-2 gap-8 mt-12">
              <div>
                <div className="text-4xl font-bold text-[#1A4D4D] mb-2">8+</div>
                <p className="text-gray-600 font-light">Anni di Esperienza</p>
              </div>
              <div>
                <div className="text-4xl font-bold text-[#1A4D4D] mb-2">150+</div>
                <p className="text-gray-600 font-light">Progetti Completati</p>
              </div>
              <div>
                <div className="text-4xl font-bold text-[#1A4D4D] mb-2">50+</div>
                <p className="text-gray-600 font-light">Clienti Soddisfatti</p>
              </div>
              <div>
                <div className="text-4xl font-bold text-[#1A4D4D] mb-2">100%</div>
                <p className="text-gray-600 font-light">Dedizione</p>
              </div>
            </div>
          </div>

          {/* Right Column - Testimonial Card */}
          <div className="relative">
            <div className="bg-[#2D5F5F] rounded-[32px] p-12 lg:p-16 relative overflow-hidden">
              {/* Decorative Elements */}
              <div className="absolute top-8 left-8 text-white/20 text-sm font-light">
                Cliente Soddisfatto
              </div>
              <div className="absolute top-8 right-8 flex gap-2">
                <div className="w-2 h-2 rounded-full bg-white/40"></div>
                <div className="w-2 h-2 rounded-full bg-white/40"></div>
                <div className="w-2 h-2 rounded-full bg-white/40"></div>
              </div>

              {/* Quote Icon */}
              <div className="w-16 h-16 flex items-center justify-center mb-8 mt-8">
                <i className="ri-double-quotes-l text-5xl text-white/30"></i>
              </div>

              {/* Testimonial Text */}
              <p className="text-white text-2xl lg:text-3xl font-light leading-relaxed mb-12">
                Lios S.r.l. ha trasformato completamente il nostro sistema gestionale. La loro professionalità e competenza tecnica hanno superato ogni aspettativa. Un partner affidabile per la crescita digitale.
              </p>

              {/* Client Info */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 rounded-full bg-white/20 flex items-center justify-center">
                    <i className="ri-user-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold text-lg">Marco Esposito</p>
                    <p className="text-white/70 text-sm font-light">CEO, TechInnovate S.p.A.</p>
                  </div>
                </div>
                <button className="w-12 h-12 rounded-full bg-white/20 hover:bg-white/30 transition-all flex items-center justify-center cursor-pointer">
                  <i className="ri-arrow-right-line text-white text-xl"></i>
                </button>
              </div>
            </div>

            {/* Background Image */}
            <div className="hidden lg:block absolute -bottom-12 -right-12 w-64 h-64 rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/6b209d8241a0edcb1fce2c73c5c3e926/9064923f9131255f8807108a09c17e0f.jpeg"
                alt="Office"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="mt-32">
          <h3 className="text-3xl font-bold text-[#2C2C2C] mb-12 text-center">I Nostri Valori</h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-[#1A4D4D]/10 rounded-2xl">
                <i className="ri-star-line text-3xl text-[#1A4D4D]"></i>
              </div>
              <h4 className="text-xl font-bold text-[#2C2C2C] mb-3">Eccellenza</h4>
              <p className="text-gray-600 font-light text-sm leading-relaxed">
                Puntiamo sempre alla massima qualità in ogni progetto
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-[#1A4D4D]/10 rounded-2xl">
                <i className="ri-team-line text-3xl text-[#1A4D4D]"></i>
              </div>
              <h4 className="text-xl font-bold text-[#2C2C2C] mb-3">Collaborazione</h4>
              <p className="text-gray-600 font-light text-sm leading-relaxed">
                Lavoriamo a stretto contatto con i nostri clienti
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-[#1A4D4D]/10 rounded-2xl">
                <i className="ri-rocket-line text-3xl text-[#1A4D4D]"></i>
              </div>
              <h4 className="text-xl font-bold text-[#2C2C2C] mb-3">Innovazione</h4>
              <p className="text-gray-600 font-light text-sm leading-relaxed">
                Utilizziamo le tecnologie più avanzate del settore
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-[#1A4D4D]/10 rounded-2xl">
                <i className="ri-shield-check-line text-3xl text-[#1A4D4D]"></i>
              </div>
              <h4 className="text-xl font-bold text-[#2C2C2C] mb-3">Affidabilità</h4>
              <p className="text-gray-600 font-light text-sm leading-relaxed">
                Garantiamo supporto continuo e soluzioni durature
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
